import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { CREATE_SURVEY_SERIES } from '../../constants';
import { createSurveySeries, updateSurveySeries } from '../../store/actions/survey';
import ButtonComponent from '../FormComponents/Button';
import TextField from '../FormComponents/TextField';
import Modal from '../Modal/Modal';
import ToastMessage from '../ToastMessage/ToastMessage';
import './SurveyForm.scss';

interface SeriesProps {
  open: boolean;
  closePopup: () => void;
  getData: () => void;
  type: string;
  seriesId?: string;
  name?: string;
}

function Series(props: SeriesProps) {
  const dispatch = useDispatch();
  const { open, closePopup, getData, type, seriesId, name } = props;
  const [surveySeriesName, setSurveySeriesName] = useState('');
  const [formClicked, setFormClicked] = useState(false);
  const [toast, setToast] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setSurveySeriesName(name);
  }, [name]);

  const closeModal = () => {
    closePopup();
    setFormClicked(false);
    setSurveySeriesName(name || '');
  };

  const addSurveySeries = () => {
    setFormClicked(true);
    if (!surveySeriesName) {
      return;
    }
    setLoading(true);
    if (type === CREATE_SURVEY_SERIES) {
      dispatch(
        createSurveySeries({ name: surveySeriesName }, (res, message) => {
          setLoading(false);
          if (res) {
            setSurveySeriesName('');
            getData();
            closeModal();
          } else {
            setToast(message || 'Opps, unknown error occured.');
          }
        }),
      );
    } else {
      dispatch(
        updateSurveySeries({ id: seriesId, name: surveySeriesName }, (res, message) => {
          setLoading(false);
          if (res) {
            setSurveySeriesName('');
            getData();
            closeModal();
          } else {
            setToast(message || 'Opps, unknown error occured.');
          }
        }),
      );
    }
  };

  const action = type === CREATE_SURVEY_SERIES ? 'Add' : 'Update';

  return (
    <>
      <Modal
        open={open}
        onClose={closeModal}
        title={`${action} survey series`}
        button={<ButtonComponent text={action} onClick={addSurveySeries} loading={loading} />}
        data={
          <div>
            <TextField
              label='Survey series'
              id='survey-series'
              variant='outlined'
              sx={{ width: 400, mt: 2 }}
              value={surveySeriesName}
              onChange={e => setSurveySeriesName(e.target.value)}
              required
              error={formClicked && !surveySeriesName}
            />
          </div>
        }
      />
      <ToastMessage toast={toast} close={() => setToast('')} messageType='error' />
    </>
  );
}

export default Series;
